"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultPaymentMethodUrl = exports.getCurrentSurveyQuestionUrl = exports.getCronofyUserInfoUrl = exports.getCronofyProfileUrl = exports.getCredentialedClinicianListUrl = exports.getCreateSurveyUrl = exports.getCreateSurveyAnswersUrl = exports.getCreateSchedulingFlowAppointmentAndDepositUrl = exports.getCreateRecurringAppointmentUrl = exports.getCreateClinicianUrl = exports.getCreateAppointmentUrl = exports.getCreateAdminUrl = exports.getCptCodesUrl = exports.getCoursesUrl = exports.getCourseWorkbookUrl = exports.getCourseWorkbookAssetUrl = exports.getCourseRecommendedGroupsUrl = exports.getCourseLessonsUrl = exports.getCourseImagesUrl = exports.getCourseImageAssetUrl = exports.getCourseByIdOrSlugUrl = exports.getCodedEncountersUrl = exports.getCodedEncounterByIdUrl = exports.getCloseBookingUrl = exports.getCliniciansForMatchingUrl = exports.getCliniciansAverageRatingByRoleUrl = exports.getClinicianStatusUrl = exports.getClinicianReviewsUrl = exports.getClinicianReviewStatsUrl = exports.getClinicianRatingAndReviewStatisticsCsvUrl = exports.getClinicianProfileUrl = exports.getClinicianPayerContractUrl = exports.getClinicianPatientsUrl = exports.getClinicianPatientUrl = exports.getClinicianNotificationPreferencesUrl = exports.getClinicianNotificationPreferencesDictionaryUrl = exports.getClinicianMedicareEligibilityUrl = exports.getClinicianMedicaidEligibilityUrl = exports.getClinicianListUrl = exports.getClinicianListByErxIdUrl = exports.getClinicianInfoUrl = exports.getClinicianImageUploadUrl = exports.getClinicianEmailUrl = exports.getClinicianCoachOnlyUrl = exports.getClinicianCalendarsUrl = exports.getClinicianBlockingEventsUrl = exports.getClinicianAverageRatingUrl = exports.getClinicianAvailablePeriodsUrl = exports.getClinicianAvailabilityValidationUrl = exports.getClinicianAvailabilityUrl = exports.getClinicianAvailabilityRulesUrl = exports.getClinicianAvailabilityReportCsvUrl = exports.getClinicianAppointmentStatisticsUrl = exports.getClinicianAppointmentStatisticsSummaryUrl = exports.getClinicianAppointmentStatisticsCsvUrl = exports.getChatInitializationUrl = exports.getChatCredentialsUrl = exports.getChargeTransactionUrl = exports.getChargeDepositForBookingUrl = exports.getChargeCodedEncounterPatientResponsibilityUrl = exports.getChannelModeratorsUrl = exports.getChannelMemberUrl = exports.getChangePatientAccountStatusUrl = exports.getChangePasswordUrl = exports.getCdnBucketImageUrl = exports.getCancelRecurringAppointmentUrl = exports.getCancelAppointmentUrl = exports.getCachedPatientPrescriptionsUrl = exports.getCIECU = exports.getBustAvailabilityCacheUrl = exports.getBookingsForNoteUrl = exports.getBookingsForAnalysisUrl = exports.getBookingsCsvUrl = exports.getBookingUrl = exports.getBasicGroupsUrl = exports.getBanUserUrl = exports.getBalanceTransferPreviewUrl = exports.getAttendGroupSessionUrl = exports.getAppointmentSchedulingFlowUrl = exports.getAppointmentSchedulingFlowTransitionUrl = exports.getAppointmentSchedulingFlowMostRecentVisitReasonUrl = exports.getAppointmentSchedulingFlowForClinicianRoleUrl = exports.getApplicationCalendarUrl = exports.getAllPricesUrl = exports.getAllGroupTopicsUrl = exports.getAdminStatusUrl = exports.getAdminReviewListUrl = exports.getAdminProfileUrl = exports.getAdminListUrl = exports.getAddModeratorsToChannelUrl = exports.getActiveUSAStates = exports.getAccountRelationsUrl = exports.getAccountRelationUrl = exports.getAccountListBySearchKeywordUrl = exports.getAccountImageUrl = exports.deleteVideoCallUrl = exports.deleteTopicFromGroupUrl = exports.deleteGroupSessionRsvpUrl = exports.createTopicAndAddToGroupUrl = exports.addTopicToGroupUrl = void 0;
exports.getPatientSurveyAnswersUrl = exports.getPatientSubscriptionHistoryUrl = exports.getPatientSmsTransactionalNotificationsAll = exports.getPatientRegistrationUrl = exports.getPatientRateBookingUrl = exports.getPatientProfileUrl = exports.getPatientPrescriptionsUrl = exports.getPatientPhoneNumberVerificationUrl = exports.getPatientPhoneNumberVerificationSkipUrl = exports.getPatientPharmacyUrl = exports.getPatientPharmaciesUrl = exports.getPatientNotificationPreferencesUrl = exports.getPatientNotificationPreferencesDictionaryUrl = exports.getPatientNotesUrl = exports.getPatientNonCancelledBookingsUrl = exports.getPatientMembershipUrl = exports.getPatientMarketingEmailPreferenceUrl = exports.getPatientLegacyCommunityOnlyUrl = exports.getPatientInsuranceSoharEligibilityUrl = exports.getPatientInsuranceRequestNotifications = exports.getPatientInsuranceEligibilityUrl = exports.getPatientInsuranceEligibilityHistoryUrl = exports.getPatientInsuranceCardsList = exports.getPatientInsuranceCards = exports.getPatientInsuranceCardAndBenefitData = exports.getPatientImageUploadUrl = exports.getPatientIdUploadUrl = exports.getPatientHasGroupSessionRatingUrl = exports.getPatientGroupSessionRatingUrl = exports.getPatientFileUrl = exports.getPatientEmployerRelationsUrl = exports.getPatientEmergencyContactsUrl = exports.getPatientEmergencyContactUrl = exports.getPatientDefaultPharmaciesUrl = exports.getPatientChatsSyncUrl = exports.getPatientCareTeamUrl = exports.getPatientCancellationReasonsUrl = exports.getPatientBookingsUrl = exports.getPatchLegacyNoteUrl = exports.getParsePatientInsuranceSoharEligibilityUrl = exports.getParsePatientInsuranceEligibilityUrl = exports.getOnboardingUrl = exports.getOnboardingTransitionUrl = exports.getOnboardingReviewIntakeUrl = exports.getNpiValidatorsUrl = exports.getNotificationsUrl = exports.getNotificationListUrl = exports.getNoClinicianAvailabilitySupportTicketUrl = exports.getNextSurveyQuestionUrl = exports.getMissedCallsUrl = exports.getMedicationsProviderUrl = exports.getMedicationsProviderNotificationsUrl = exports.getMedicationsProviderNotificationsCountUrl = exports.getMakeTransferUrl = exports.getMakeTransferNewUrl = exports.getLessonsUrl = exports.getLessonImageUrl = exports.getInsuranceSubmissionFlowUrl = exports.getInsuranceSubmissionFlowTransitionUrl = exports.getInactiveListUrl = exports.getIcdCodesUrl = exports.getHealthOutcomesReportSendingUrl = exports.getHealthOutcomesPatientExportUrl = exports.getHasEngagedGroupSessionForPatientUrl = exports.getGuidByNicknameUrl = exports.getGroupsWithTopicUrl = exports.getGroupsByClinicianUrl = exports.getGroupVideoTokenUrl = exports.getGroupUrl = exports.getGroupTopicsByGroupUrl = exports.getGroupSessionsUrl = exports.getGroupSessionRsvpsByPatientUrl = exports.getGroupSessionRsvpUrl = exports.getGroupSessionParticipationUrl = exports.getGroupSessionParticipationForPatientUrl = exports.getGroupReviewsUrl = exports.getGroupRecommendationsByPatientUrl = exports.getGroupRatingAndReviewStatisticsCsvUrl = exports.getGroupImageUploadUrl = exports.getGroupFavoriteUrl = exports.getGroupChatUrl = exports.getGroupAverageRatingUrl = exports.getGeneratedNickname = exports.getFilteredGroupUrl = exports.getFeaturedCourseUrl = exports.getExtendBookingUrl = exports.getExtendBookingConflictsUrl = exports.getExportRevenueReportCsvUrl = exports.getExportRetentionDataCsvUrl = exports.getExportLtvReportCsvUrl = exports.getExportCliniciansListCsvUrl = exports.getExportActiveMembershipReportCsvUrl = exports.getEntityDetailsUrl = exports.getEmployersUrl = exports.getEmailTemplatesUrl = exports.getDownloadPayerFeeSchedulesUrl = exports.getDownloadMembersForMigrationToCommunityApp = exports.getDoseSpotMaintenanceUrl = exports.getDiscountedPricesUrl = exports.getDeletePatientEmergencyContactUrl = void 0;
exports.postUploadPayerDataUrl = exports.postUploadPayerContractDataUrl = exports.postUploadClinicianPayerContractDataUrl = exports.postGroupSessionsRatesDataUrl = exports.postBookingClinicianRatesDataUrl = exports.newTopicUrl = exports.getVideoCallUrl = exports.getVideoCallStartUrl = exports.getVideoArchiveUrl = exports.getValidatorsUrl = exports.getValidateErxIdrUrl = exports.getValidateDepositPaymentForBookingUrl = exports.getUserSubscriptionUrl = exports.getUserPublicChatBanUrl = exports.getUserPreferencesUrl = exports.getUserPingUrl = exports.getUserInfoUrl = exports.getUsaStateByZipUrl = exports.getUploadServiceFacilitiesUrl = exports.getUploadPayerFeeSchedulesUrl = exports.getUploadPatientEmployerRelationsUrl = exports.getUploadInsuranceDataUrl = exports.getUpdateRelatedGroupsUrl = exports.getUpdateRecurringAppointmentUrl = exports.getUpdatePatientChatUrl = exports.getUpdateAppointmentUrl = exports.getUpdateAppointmentClinicianRateUrl = exports.getUnbanUserUrl = exports.getTransactionsForBookingUrl = exports.getTopCommunityMessages = exports.getTherapyAssessmentReportUrl = exports.getTempestStripeCopyUploadUrl = exports.getTempestMigrationUploadUrl = exports.getSurveysListUrl = exports.getSurveyUrl = exports.getSurveyResultUrl = exports.getSubscriptionProductsUrl = exports.getSoharTestProdUploadUrl = exports.getSmsTemplatesUrl = exports.getSinglePayerFeeScheduleUrl = exports.getSingleLessonUrl = exports.getSimulationUrl = exports.getSignOutUrl = exports.getSignInUrl = exports.getSessionUrl = exports.getSessionNotesUrl = exports.getServiceFacilitiesUrl = exports.getSearchPatientsUrl = exports.getSearchIcdCodeUrl = exports.getSearchCliniciansUrl = exports.getSchedulingTherapistRecommendationUrl = exports.getSchedulingPhysicianRecommendationUrl = exports.getSchedulingElementTokenUrl = exports.getSchedulingAccessTokenUrl = exports.getReviewQuestionsUrl = exports.getRetryTransactionUrl = exports.getResetPasswordUrl = exports.getResendVerificationEmailUrl = exports.getRefundTransactionUrl = exports.getRecurringAvailabilityUrl = exports.getPublicFacingReviewsUrl = exports.getPublicClinicianListUrl = exports.getPricesForPatientUrl = exports.getPrevSurveyQuestionUrl = exports.getPostAppointmentStateUrl = exports.getPostAppointmentClinicianStateUrl = exports.getPaymentMethodsUrl = exports.getPaymentMethodUrl = exports.getPayers = exports.getPayerFeeSchedulesUrl = exports.getPayerFeeScheduleSearchUrl = exports.getPayerContractListUrl = exports.getPatientsStateZipInconsistenciesCsvUrl = exports.getPatientWaitingListUrl = exports.getPatientTransactionsUrl = exports.getPatientTransactionHistoryUrl = exports.getPatientTopicsUrl = exports.getPatientSwitchToInsurance = exports.getPatientSwitchInsurance = exports.getPatientSwitchFromInsurance = void 0;
var _lodash = require("lodash");
var _queryString = require("query-string");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var patientManagementSvcUrl = '/api/patient-management/v1';
var paymentSvcUrl = '/api/payment/v1';
var communicationSvcUrl = '/api/communication/v1';
var userProfileSvcUrl = '/api/user-profile/v1';

// user-profile
var getAdminListUrl = function getAdminListUrl() {
  return "".concat(userProfileSvcUrl, "/admins");
};
exports.getAdminListUrl = getAdminListUrl;
var getAdminProfileUrl = function getAdminProfileUrl(accountId) {
  return "".concat(userProfileSvcUrl, "/admins/").concat(accountId, "/profile");
};
exports.getAdminProfileUrl = getAdminProfileUrl;
var getAdminStatusUrl = function getAdminStatusUrl(accountId) {
  return "".concat(userProfileSvcUrl, "/admins/").concat(accountId, "/status");
};
exports.getAdminStatusUrl = getAdminStatusUrl;
var getPatientProfileUrl = function getPatientProfileUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(userProfileSvcUrl, "/patients/").concat(accountId, "/profile");
};
exports.getPatientProfileUrl = getPatientProfileUrl;
var getPatientIdUploadUrl = function getPatientIdUploadUrl(patientId) {
  return "".concat(userProfileSvcUrl, "/patients/").concat(patientId, "/upload");
};
exports.getPatientIdUploadUrl = getPatientIdUploadUrl;
var getPatientImageUploadUrl = function getPatientImageUploadUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(userProfileSvcUrl, "/patients/").concat(patientId, "/file");
};
exports.getPatientImageUploadUrl = getPatientImageUploadUrl;
var getPatientCareTeamUrl = function getPatientCareTeamUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(userProfileSvcUrl, "/patients/").concat(accountId, "/careteam");
};
exports.getPatientCareTeamUrl = getPatientCareTeamUrl;
var getPatientEmergencyContactUrl = function getPatientEmergencyContactUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(userProfileSvcUrl, "/patients/").concat(accountId, "/emergency-contact");
};
exports.getPatientEmergencyContactUrl = getPatientEmergencyContactUrl;
var getDeletePatientEmergencyContactUrl = function getDeletePatientEmergencyContactUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var id = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(userProfileSvcUrl, "/patients/").concat(accountId, "/emergency-contacts/").concat(id);
};
exports.getDeletePatientEmergencyContactUrl = getDeletePatientEmergencyContactUrl;
var getPatientEmergencyContactsUrl = function getPatientEmergencyContactsUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(userProfileSvcUrl, "/patients/").concat(accountId, "/emergency-contacts");
};
exports.getPatientEmergencyContactsUrl = getPatientEmergencyContactsUrl;
var getClinicianListUrl = function getClinicianListUrl() {
  return "".concat(userProfileSvcUrl, "/clinicians");
};
exports.getClinicianListUrl = getClinicianListUrl;
var getCredentialedClinicianListUrl = function getCredentialedClinicianListUrl() {
  return "".concat(userProfileSvcUrl, "/clinicians/credentialed");
};
exports.getCredentialedClinicianListUrl = getCredentialedClinicianListUrl;
var getClinicianListByErxIdUrl = function getClinicianListByErxIdUrl() {
  return "".concat(userProfileSvcUrl, "/clinicians/erx");
};
exports.getClinicianListByErxIdUrl = getClinicianListByErxIdUrl;
var getClinicianProfileUrl = function getClinicianProfileUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(userProfileSvcUrl, "/clinicians/").concat(accountId, "/profile");
};
exports.getClinicianProfileUrl = getClinicianProfileUrl;
var getClinicianMedicareEligibilityUrl = function getClinicianMedicareEligibilityUrl(accountId) {
  return "".concat(userProfileSvcUrl, "/clinicians/").concat(accountId, "/profile/medicare-eligibility");
};
exports.getClinicianMedicareEligibilityUrl = getClinicianMedicareEligibilityUrl;
var getClinicianMedicaidEligibilityUrl = function getClinicianMedicaidEligibilityUrl(accountId) {
  return "".concat(userProfileSvcUrl, "/clinicians/").concat(accountId, "/profile/medicaid-eligibility");
};
exports.getClinicianMedicaidEligibilityUrl = getClinicianMedicaidEligibilityUrl;
var getClinicianEmailUrl = function getClinicianEmailUrl(accountId) {
  return "".concat(userProfileSvcUrl, "/clinicians/").concat(accountId, "/email");
};
exports.getClinicianEmailUrl = getClinicianEmailUrl;
var getClinicianStatusUrl = function getClinicianStatusUrl(accountId) {
  return "".concat(userProfileSvcUrl, "/clinicians/").concat(accountId, "/status");
};
exports.getClinicianStatusUrl = getClinicianStatusUrl;
var getClinicianCoachOnlyUrl = function getClinicianCoachOnlyUrl(accountId) {
  return "".concat(userProfileSvcUrl, "/clinicians/").concat(accountId, "/coach-only");
};
exports.getClinicianCoachOnlyUrl = getClinicianCoachOnlyUrl;
var getAccountImageUrl = function getAccountImageUrl(id) {
  return "".concat(userProfileSvcUrl, "/accounts/").concat(id, "/image");
};
exports.getAccountImageUrl = getAccountImageUrl;
var getPatientFileUrl = function getPatientFileUrl(accountId, filename) {
  return "".concat(userProfileSvcUrl, "/patients/").concat(accountId, "/file/").concat(filename);
};
exports.getPatientFileUrl = getPatientFileUrl;
var getClinicianImageUploadUrl = function getClinicianImageUploadUrl(accountId) {
  return "".concat(userProfileSvcUrl, "/clinicians/").concat(accountId, "/upload");
};
exports.getClinicianImageUploadUrl = getClinicianImageUploadUrl;
var getClinicianPatientsUrl = function getClinicianPatientsUrl(_ref) {
  var _ref$accountId = _ref.accountId,
    accountId = _ref$accountId === void 0 ? 'me' : _ref$accountId,
    parameters = _ref.parameters;
  return "".concat(userProfileSvcUrl, "/clinicians/").concat(accountId, "/patients?").concat((0, _queryString.stringify)(parameters));
};
exports.getClinicianPatientsUrl = getClinicianPatientsUrl;
var getClinicianPatientUrl = function getClinicianPatientUrl(_ref2) {
  var _ref2$accountId = _ref2.accountId,
    accountId = _ref2$accountId === void 0 ? 'me' : _ref2$accountId,
    patientId = _ref2.patientId;
  return "".concat(userProfileSvcUrl, "/clinicians/").concat(accountId, "/patients/").concat(patientId);
};
exports.getClinicianPatientUrl = getClinicianPatientUrl;
var getClinicianAppointmentStatisticsSummaryUrl = function getClinicianAppointmentStatisticsSummaryUrl(clinicianId, startDate, endDate) {
  return "".concat(communicationSvcUrl, "/statistics/").concat(clinicianId, "/summary?startDate=").concat(startDate, "&endDate=").concat(endDate);
};
exports.getClinicianAppointmentStatisticsSummaryUrl = getClinicianAppointmentStatisticsSummaryUrl;
var getClinicianAppointmentStatisticsUrl = function getClinicianAppointmentStatisticsUrl(clinicianId, startDate, endDate) {
  return "".concat(communicationSvcUrl, "/statistics/").concat(clinicianId, "/videocalls?startDate=").concat(startDate, "&endDate=").concat(endDate);
};
exports.getClinicianAppointmentStatisticsUrl = getClinicianAppointmentStatisticsUrl;
var getVideoArchiveUrl = function getVideoArchiveUrl(fileName) {
  return "".concat(process.env.REACT_APP_APPLICATION_URL).concat(communicationSvcUrl, "/statistics/").concat(fileName, "/video");
};
exports.getVideoArchiveUrl = getVideoArchiveUrl;
var getClinicianAppointmentStatisticsCsvUrl = function getClinicianAppointmentStatisticsCsvUrl(clinicianId, startDate, endDate) {
  return "".concat(communicationSvcUrl, "/csv/").concat(clinicianId, "/statistics?startDate=").concat(startDate, "&endDate=").concat(endDate);
};
exports.getClinicianAppointmentStatisticsCsvUrl = getClinicianAppointmentStatisticsCsvUrl;
var getClinicianReviewStatsUrl = function getClinicianReviewStatsUrl() {
  var clinicianId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(communicationSvcUrl, "/rating-review/clinician/").concat(clinicianId);
};
exports.getClinicianReviewStatsUrl = getClinicianReviewStatsUrl;
var getInactiveListUrl = function getInactiveListUrl() {
  return "".concat(userProfileSvcUrl, "/patients/inactive");
};
exports.getInactiveListUrl = getInactiveListUrl;
var getClinicianInfoUrl = function getClinicianInfoUrl(clinicianId) {
  return "".concat(userProfileSvcUrl, "/patients/clinicians/").concat(clinicianId);
};
exports.getClinicianInfoUrl = getClinicianInfoUrl;
var getSearchPatientsUrl = function getSearchPatientsUrl(query, clinicianId) {
  return "".concat(userProfileSvcUrl, "/patients/search").concat(clinicianId ? "/".concat(clinicianId) : '', "?").concat((0, _queryString.stringify)(query));
};
exports.getSearchPatientsUrl = getSearchPatientsUrl;
var getSearchCliniciansUrl = function getSearchCliniciansUrl(query) {
  return "".concat(userProfileSvcUrl, "/clinicians/search?").concat((0, _queryString.stringify)(query));
};
exports.getSearchCliniciansUrl = getSearchCliniciansUrl;
var getCliniciansForMatchingUrl = function getCliniciansForMatchingUrl(patientId, clinicianRole) {
  return "".concat(userProfileSvcUrl, "/patients/").concat(patientId, "/clinicians/").concat(clinicianRole);
};
exports.getCliniciansForMatchingUrl = getCliniciansForMatchingUrl;
var getChatInitializationUrl = function getChatInitializationUrl(patientId) {
  return "".concat(communicationSvcUrl, "/chats/accounts/").concat(patientId);
};

// validators
exports.getChatInitializationUrl = getChatInitializationUrl;
var getValidatorsUrl = function getValidatorsUrl(name, value) {
  return "".concat(userProfileSvcUrl, "/validators/").concat(name, "/").concat(value);
};

// erx
exports.getValidatorsUrl = getValidatorsUrl;
var getPatientPrescriptionsUrl = function getPatientPrescriptionsUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/prescriptions/patients/").concat(patientId, "/prescriptions");
};
exports.getPatientPrescriptionsUrl = getPatientPrescriptionsUrl;
var getCachedPatientPrescriptionsUrl = function getCachedPatientPrescriptionsUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/prescriptions/patients/").concat(patientId, "/prescriptions/cached");
};
exports.getCachedPatientPrescriptionsUrl = getCachedPatientPrescriptionsUrl;
var getPatientPharmaciesUrl = function getPatientPharmaciesUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var query = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(patientManagementSvcUrl, "/pharmacies/patients/").concat(accountId, "/search").concat(query ? '?' + (0, _queryString.stringify)(query) : '');
};
exports.getPatientPharmaciesUrl = getPatientPharmaciesUrl;
var getPatientDefaultPharmaciesUrl = function getPatientDefaultPharmaciesUrl(accountId) {
  return "".concat(patientManagementSvcUrl, "/pharmacies/patients/").concat(accountId);
};
exports.getPatientDefaultPharmaciesUrl = getPatientDefaultPharmaciesUrl;
var getPatientPharmacyUrl = function getPatientPharmacyUrl(pharmacyId) {
  var patientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'me';
  return "".concat(patientManagementSvcUrl, "/pharmacies/").concat(pharmacyId, "/patients/").concat(patientId);
};
exports.getPatientPharmacyUrl = getPatientPharmacyUrl;
var getDoseSpotMaintenanceUrl = function getDoseSpotMaintenanceUrl() {
  return "".concat(userProfileSvcUrl, "/maintenance/dosespot/account");
};
exports.getDoseSpotMaintenanceUrl = getDoseSpotMaintenanceUrl;
var getMedicationsProviderUrl = function getMedicationsProviderUrl(patientId) {
  return "".concat(patientManagementSvcUrl, "/medications-provider/clinicians/me/patients/").concat(patientId, "/medications-ui-url");
};
exports.getMedicationsProviderUrl = getMedicationsProviderUrl;
var getMedicationsProviderNotificationsCountUrl = function getMedicationsProviderNotificationsCountUrl() {
  return "".concat(patientManagementSvcUrl, "/medications-provider/clinicians/me/notifications-count");
};
exports.getMedicationsProviderNotificationsCountUrl = getMedicationsProviderNotificationsCountUrl;
var getMedicationsProviderNotificationsUrl = function getMedicationsProviderNotificationsUrl() {
  return "".concat(patientManagementSvcUrl, "/medications-provider/clinicians/me/notifications-url");
};
exports.getMedicationsProviderNotificationsUrl = getMedicationsProviderNotificationsUrl;
var getValidateErxIdrUrl = function getValidateErxIdrUrl(erxId) {
  return "".concat(patientManagementSvcUrl, "/medications-provider/verify-erx-id/").concat(erxId);
};

// accounts
exports.getValidateErxIdrUrl = getValidateErxIdrUrl;
var getUserInfoUrl = function getUserInfoUrl() {
  var refreshSession = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return refreshSession ? '/api/accounts/me?refresh=true' : '/api/accounts/me';
};
exports.getUserInfoUrl = getUserInfoUrl;
var getSimulationUrl = function getSimulationUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "/api/accounts/simulate/".concat(accountId);
};
exports.getSimulationUrl = getSimulationUrl;
var getUserPingUrl = function getUserPingUrl() {
  return '/api/accounts/ping';
};
exports.getUserPingUrl = getUserPingUrl;
var getCreateAdminUrl = function getCreateAdminUrl(roleNumber) {
  return "".concat(userProfileSvcUrl, "/accounts/admins/").concat(roleNumber);
};
exports.getCreateAdminUrl = getCreateAdminUrl;
var getCreateClinicianUrl = function getCreateClinicianUrl(roleNumber) {
  return "".concat(userProfileSvcUrl, "/accounts/clinicians/").concat(roleNumber);
};
exports.getCreateClinicianUrl = getCreateClinicianUrl;
var getUserPreferencesUrl = function getUserPreferencesUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var path = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(userProfileSvcUrl, "/accounts/").concat(accountId, "/preferences/").concat(path);
};
exports.getUserPreferencesUrl = getUserPreferencesUrl;
var getResendVerificationEmailUrl = function getResendVerificationEmailUrl() {
  return "".concat(userProfileSvcUrl, "/accounts/verify");
};
exports.getResendVerificationEmailUrl = getResendVerificationEmailUrl;
var getAccountListBySearchKeywordUrl = function getAccountListBySearchKeywordUrl(keyword) {
  return "".concat(userProfileSvcUrl, "/accounts/search/").concat(keyword);
};
exports.getAccountListBySearchKeywordUrl = getAccountListBySearchKeywordUrl;
var getAccountRelationsUrl = function getAccountRelationsUrl() {
  return "".concat(userProfileSvcUrl, "/account-relations");
};
exports.getAccountRelationsUrl = getAccountRelationsUrl;
var getAccountRelationUrl = function getAccountRelationUrl(relationId) {
  return "".concat(userProfileSvcUrl, "/account-relations/").concat(relationId);
};
exports.getAccountRelationUrl = getAccountRelationUrl;
var getChangePatientAccountStatusUrl = function getChangePatientAccountStatusUrl(accountId) {
  return "".concat(userProfileSvcUrl, "/patients/").concat(accountId, "/status");
};

// surveys
exports.getChangePatientAccountStatusUrl = getChangePatientAccountStatusUrl;
var getSurveysListUrl = function getSurveysListUrl(surveyType) {
  return "".concat(patientManagementSvcUrl, "/surveys").concat(surveyType ? '?type=' + surveyType : '');
};
exports.getSurveysListUrl = getSurveysListUrl;
var getSurveyResultUrl = function getSurveyResultUrl(surveyId) {
  return "".concat(patientManagementSvcUrl, "/surveys/").concat(surveyId, "/patients/me/result");
};
exports.getSurveyResultUrl = getSurveyResultUrl;
var getCreateSurveyUrl = function getCreateSurveyUrl() {
  return "".concat(patientManagementSvcUrl, "/surveys/start");
};
exports.getCreateSurveyUrl = getCreateSurveyUrl;
var getCreateSurveyAnswersUrl = function getCreateSurveyAnswersUrl(surveyId) {
  return "".concat(patientManagementSvcUrl, "/surveys/").concat(surveyId, "/answers");
};
exports.getCreateSurveyAnswersUrl = getCreateSurveyAnswersUrl;
var getNextSurveyQuestionUrl = function getNextSurveyQuestionUrl(surveyId, questionId) {
  return "".concat(patientManagementSvcUrl, "/surveys/").concat(surveyId, "/patients/me/questions/").concat(questionId, "/next");
};
exports.getNextSurveyQuestionUrl = getNextSurveyQuestionUrl;
var getPrevSurveyQuestionUrl = function getPrevSurveyQuestionUrl(surveyId, questionId) {
  return "".concat(patientManagementSvcUrl, "/surveys/").concat(surveyId, "/patients/me/questions/").concat(questionId, "/prev");
};
exports.getPrevSurveyQuestionUrl = getPrevSurveyQuestionUrl;
var getCurrentSurveyQuestionUrl = function getCurrentSurveyQuestionUrl(surveyId) {
  return "".concat(patientManagementSvcUrl, "/surveys/").concat(surveyId, "/patients/me/questions/current");
};
exports.getCurrentSurveyQuestionUrl = getCurrentSurveyQuestionUrl;
var getPatientSurveyAnswersUrl = function getPatientSurveyAnswersUrl(_ref3) {
  var patientId = _ref3.patientId,
    surveyType = _ref3.surveyType,
    _ref3$surveyStatuses = _ref3.surveyStatuses,
    surveyStatuses = _ref3$surveyStatuses === void 0 ? [] : _ref3$surveyStatuses,
    _ref3$patientSurveyId = _ref3.patientSurveyId,
    patientSurveyId = _ref3$patientSurveyId === void 0 ? null : _ref3$patientSurveyId;
  return "".concat(patientManagementSvcUrl, "/surveys/").concat(surveyType, "/patients/").concat(patientId, "/patient-surveys/").concat(patientSurveyId, "/answers?").concat((0, _queryString.stringify)({
    surveyStatuses: surveyStatuses
  }));
};
exports.getPatientSurveyAnswersUrl = getPatientSurveyAnswersUrl;
var getSurveyUrl = function getSurveyUrl(surveyType) {
  return "".concat(patientManagementSvcUrl, "/surveys/").concat(surveyType);
};
exports.getSurveyUrl = getSurveyUrl;
var getTherapyAssessmentReportUrl = function getTherapyAssessmentReportUrl() {
  return "".concat(patientManagementSvcUrl, "/surveys/therapy-assessments-report");
};

// billing codes
exports.getTherapyAssessmentReportUrl = getTherapyAssessmentReportUrl;
var getIcdCodesUrl = function getIcdCodesUrl() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return "".concat(patientManagementSvcUrl, "/billing-codes/icd-codes?").concat((0, _queryString.stringify)(params));
};
exports.getIcdCodesUrl = getIcdCodesUrl;
var getSearchIcdCodeUrl = function getSearchIcdCodeUrl(query) {
  return "".concat(patientManagementSvcUrl, "/billing-codes/icd-codes/search?").concat((0, _queryString.stringify)(query));
};
exports.getSearchIcdCodeUrl = getSearchIcdCodeUrl;
var getCptCodesUrl = function getCptCodesUrl() {
  return "".concat(patientManagementSvcUrl, "/billing-codes/cpt-codes");
};

// other
exports.getCptCodesUrl = getCptCodesUrl;
var getResetPasswordUrl = function getResetPasswordUrl() {
  return '/reset-password';
};
exports.getResetPasswordUrl = getResetPasswordUrl;
var getSignInUrl = function getSignInUrl() {
  return '/sign-in';
};
exports.getSignInUrl = getSignInUrl;
var getSignOutUrl = function getSignOutUrl() {
  return '/sign-out';
};
exports.getSignOutUrl = getSignOutUrl;
var getChangePasswordUrl = function getChangePasswordUrl() {
  return '/api/accounts/change-password';
};
exports.getChangePasswordUrl = getChangePasswordUrl;
var getPatientRegistrationUrl = function getPatientRegistrationUrl() {
  return '/api/accounts/patients';
};
exports.getPatientRegistrationUrl = getPatientRegistrationUrl;
var getPatientWaitingListUrl = function getPatientWaitingListUrl() {
  return "".concat(userProfileSvcUrl, "/patients-waiting-list");
};
exports.getPatientWaitingListUrl = getPatientWaitingListUrl;
var getPatientNotesUrl = function getPatientNotesUrl(patientId) {
  return "".concat(patientManagementSvcUrl, "/notes/patient/").concat(patientId);
};
exports.getPatientNotesUrl = getPatientNotesUrl;
var getSessionNotesUrl = function getSessionNotesUrl(clinicianId, bookingId) {
  return "".concat(patientManagementSvcUrl, "/notes/clinician/").concat(clinicianId).concat(bookingId ? '/booking/' + bookingId : '');
};
exports.getSessionNotesUrl = getSessionNotesUrl;
var getPatchLegacyNoteUrl = function getPatchLegacyNoteUrl(patientId, noteId) {
  return "".concat(patientManagementSvcUrl, "/notes/").concat(noteId, "/patient/").concat(patientId, "/legacy");
};
exports.getPatchLegacyNoteUrl = getPatchLegacyNoteUrl;
var getPatientRateBookingUrl = function getPatientRateBookingUrl(bookingId) {
  return "".concat(communicationSvcUrl, "/rating-review/account/me/booking/").concat(bookingId);
};
exports.getPatientRateBookingUrl = getPatientRateBookingUrl;
var getPatientGroupSessionRatingUrl = function getPatientGroupSessionRatingUrl(sessionId) {
  return "".concat(communicationSvcUrl, "/rating-review/account/me/group-session/").concat(sessionId);
};
exports.getPatientGroupSessionRatingUrl = getPatientGroupSessionRatingUrl;
var getPatientHasGroupSessionRatingUrl = function getPatientHasGroupSessionRatingUrl(sessionId) {
  return "".concat(communicationSvcUrl, "/rating-review/account/me/group-session/").concat(sessionId, "/has-review");
};
exports.getPatientHasGroupSessionRatingUrl = getPatientHasGroupSessionRatingUrl;
var getNotificationListUrl = function getNotificationListUrl(_ref4) {
  var userId = _ref4.userId,
    filters = _ref4.filters,
    page = _ref4.page,
    limit = _ref4.limit,
    _ref4$sort = _ref4.sort,
    sort = _ref4$sort === void 0 ? 'updatedAt' : _ref4$sort,
    _ref4$order = _ref4.order,
    order = _ref4$order === void 0 ? 'desc' : _ref4$order,
    endpointSlug = _ref4.endpointSlug;
  return "".concat(communicationSvcUrl, "/notifications/").concat(endpointSlug, "/").concat(userId, "/?").concat((0, _queryString.stringify)(_objectSpread({
    page: page,
    limit: limit,
    sort: sort,
    order: order
  }, filters)));
};
exports.getNotificationListUrl = getNotificationListUrl;
var getReviewQuestionsUrl = function getReviewQuestionsUrl() {
  return "".concat(communicationSvcUrl, "/rating-review/questions");
};
exports.getReviewQuestionsUrl = getReviewQuestionsUrl;
var getAdminReviewListUrl = function getAdminReviewListUrl(_ref5) {
  var page = _ref5.page,
    limit = _ref5.limit,
    _ref5$sort = _ref5.sort,
    sort = _ref5$sort === void 0 ? 'type' : _ref5$sort,
    _ref5$order = _ref5.order,
    order = _ref5$order === void 0 ? 'desc' : _ref5$order,
    filter = _ref5.filter;
  return "".concat(communicationSvcUrl, "/rating-review?").concat((0, _queryString.stringify)({
    page: page,
    limit: limit,
    sort: sort,
    order: order,
    filter: filter
  }));
};
exports.getAdminReviewListUrl = getAdminReviewListUrl;
var getEntityDetailsUrl = function getEntityDetailsUrl(id) {
  return "".concat(communicationSvcUrl, "/rating-review/").concat(id, "/me/entity-details");
};
exports.getEntityDetailsUrl = getEntityDetailsUrl;
var getClinicianReviewsUrl = function getClinicianReviewsUrl(clinicianId, startDate, endDate) {
  return "".concat(communicationSvcUrl, "/rating-review/clinician/").concat(clinicianId, "/reviews?startDate=").concat(startDate, "&endDate=").concat(endDate);
};
exports.getClinicianReviewsUrl = getClinicianReviewsUrl;
var getClinicianAverageRatingUrl = function getClinicianAverageRatingUrl(clinicianId) {
  return "".concat(communicationSvcUrl, "/rating-review/clinician/").concat(clinicianId, "/average-rating");
};
exports.getClinicianAverageRatingUrl = getClinicianAverageRatingUrl;
var getCliniciansAverageRatingByRoleUrl = function getCliniciansAverageRatingByRoleUrl() {
  return "".concat(communicationSvcUrl, "/rating-review/rating-by-clinician-role");
};
exports.getCliniciansAverageRatingByRoleUrl = getCliniciansAverageRatingByRoleUrl;
var getGuidByNicknameUrl = function getGuidByNicknameUrl(nickname) {
  return "".concat(userProfileSvcUrl, "/accounts/").concat(nickname, "/profile");
};
exports.getGuidByNicknameUrl = getGuidByNicknameUrl;
var getMissedCallsUrl = function getMissedCallsUrl(startDate, endDate) {
  return "".concat(communicationSvcUrl, "/csv/absent-participants?startDate=").concat(startDate, "&endDate=").concat(endDate);
};

// payer (insurance)
exports.getMissedCallsUrl = getMissedCallsUrl;
var postUploadPayerDataUrl = function postUploadPayerDataUrl(_ref6) {
  var execute = _ref6.execute;
  return "".concat(patientManagementSvcUrl, "/payers/bulk-upload?execute=").concat(execute);
};
exports.postUploadPayerDataUrl = postUploadPayerDataUrl;
var postUploadPayerContractDataUrl = function postUploadPayerContractDataUrl(_ref7) {
  var execute = _ref7.execute;
  return "".concat(patientManagementSvcUrl, "/payer-contracts/upload/bulk?execute=").concat(execute);
};
exports.postUploadPayerContractDataUrl = postUploadPayerContractDataUrl;
var postUploadClinicianPayerContractDataUrl = function postUploadClinicianPayerContractDataUrl(_ref8) {
  var execute = _ref8.execute;
  return "".concat(patientManagementSvcUrl, "/clinician-payer-contracts/upload/bulk?execute=").concat(execute);
};
exports.postUploadClinicianPayerContractDataUrl = postUploadClinicianPayerContractDataUrl;
var getClinicianPayerContractUrl = function getClinicianPayerContractUrl(id) {
  return "".concat(patientManagementSvcUrl, "/clinician-payer-contracts/").concat(id);
};
exports.getClinicianPayerContractUrl = getClinicianPayerContractUrl;
var getPayerContractListUrl = function getPayerContractListUrl(payerContractId) {
  return "".concat(patientManagementSvcUrl, "/payer-contracts").concat(payerContractId ? '/' + payerContractId : '');
};
exports.getPayerContractListUrl = getPayerContractListUrl;
var getPayers = function getPayers() {
  return "".concat(patientManagementSvcUrl, "/payers");
};
exports.getPayers = getPayers;
var getUploadPayerFeeSchedulesUrl = function getUploadPayerFeeSchedulesUrl(_ref9) {
  var execute = _ref9.execute;
  return "".concat(patientManagementSvcUrl, "/payer-fee-schedules/bulk-upload?execute=").concat(execute);
};
exports.getUploadPayerFeeSchedulesUrl = getUploadPayerFeeSchedulesUrl;
var getPayerFeeSchedulesUrl = function getPayerFeeSchedulesUrl() {
  return "".concat(patientManagementSvcUrl, "/payer-fee-schedules");
};
exports.getPayerFeeSchedulesUrl = getPayerFeeSchedulesUrl;
var getSinglePayerFeeScheduleUrl = function getSinglePayerFeeScheduleUrl(id) {
  return "".concat(patientManagementSvcUrl, "/payer-fee-schedules/").concat(id);
};
exports.getSinglePayerFeeScheduleUrl = getSinglePayerFeeScheduleUrl;
var getPayerFeeScheduleSearchUrl = function getPayerFeeScheduleSearchUrl(_ref10) {
  var cptCode = _ref10.cptCode,
    payerId = _ref10.payerId,
    geography = _ref10.geography,
    date = _ref10.date;
  return "".concat(patientManagementSvcUrl, "/payer-fee-schedules/search?").concat((0, _queryString.stringify)({
    cptCode: cptCode,
    payerId: payerId,
    geography: geography,
    date: date
  }));
};

// onboarding
exports.getPayerFeeScheduleSearchUrl = getPayerFeeScheduleSearchUrl;
var getOnboardingUrl = function getOnboardingUrl() {
  return "".concat(patientManagementSvcUrl, "/onboarding");
};
exports.getOnboardingUrl = getOnboardingUrl;
var getOnboardingTransitionUrl = function getOnboardingTransitionUrl() {
  return "".concat(patientManagementSvcUrl, "/onboarding/transition");
};
exports.getOnboardingTransitionUrl = getOnboardingTransitionUrl;
var getOnboardingReviewIntakeUrl = function getOnboardingReviewIntakeUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/onboarding/patients/").concat(patientId, "/profile-review");
};
exports.getOnboardingReviewIntakeUrl = getOnboardingReviewIntakeUrl;
var getSubscriptionProductsUrl = function getSubscriptionProductsUrl() {
  return "".concat(paymentSvcUrl, "/subscriptions");
};
exports.getSubscriptionProductsUrl = getSubscriptionProductsUrl;
var getUserSubscriptionUrl = function getUserSubscriptionUrl() {
  return "".concat(paymentSvcUrl, "/subscriptions/available");
};
exports.getUserSubscriptionUrl = getUserSubscriptionUrl;
var getActiveUSAStates = function getActiveUSAStates() {
  var includeCareSignupFreezed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return "".concat(communicationSvcUrl, "/usa-states/active?").concat((0, _queryString.stringify)({
    includeCareSignupFreezed: includeCareSignupFreezed
  }));
};

// insurance
exports.getActiveUSAStates = getActiveUSAStates;
var getInsuranceSubmissionFlowUrl = function getInsuranceSubmissionFlowUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/insurance-submission-flow/").concat(accountId);
};
exports.getInsuranceSubmissionFlowUrl = getInsuranceSubmissionFlowUrl;
var getInsuranceSubmissionFlowTransitionUrl = function getInsuranceSubmissionFlowTransitionUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/insurance-submission-flow/").concat(accountId, "/transition");
};
exports.getInsuranceSubmissionFlowTransitionUrl = getInsuranceSubmissionFlowTransitionUrl;
var getServiceFacilitiesUrl = function getServiceFacilitiesUrl() {
  return "".concat(patientManagementSvcUrl, "/service-facilities");
};
exports.getServiceFacilitiesUrl = getServiceFacilitiesUrl;
var getUploadInsuranceDataUrl = function getUploadInsuranceDataUrl(_ref11) {
  var execute = _ref11.execute;
  return "".concat(userProfileSvcUrl, "/patient-insurance/bulk-upload?execute=").concat(execute);
};
exports.getUploadInsuranceDataUrl = getUploadInsuranceDataUrl;
var getUploadServiceFacilitiesUrl = function getUploadServiceFacilitiesUrl() {
  return "".concat(userProfileSvcUrl, "/patient-insurance/service-facilities");
};
exports.getUploadServiceFacilitiesUrl = getUploadServiceFacilitiesUrl;
var getPatientInsuranceCards = function getPatientInsuranceCards() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(userProfileSvcUrl, "/patient-insurance/").concat(accountId, "/cards");
};
exports.getPatientInsuranceCards = getPatientInsuranceCards;
var getPatientInsuranceEligibilityUrl = function getPatientInsuranceEligibilityUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var cardId = arguments.length > 1 ? arguments[1] : undefined;
  var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return "".concat(userProfileSvcUrl, "/patient-insurance/").concat(accountId, "/cards/").concat(cardId, "/eligibility?").concat((0, _queryString.stringify)({
    force: force
  }));
};
exports.getPatientInsuranceEligibilityUrl = getPatientInsuranceEligibilityUrl;
var getParsePatientInsuranceEligibilityUrl = function getParsePatientInsuranceEligibilityUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var cardId = arguments.length > 1 ? arguments[1] : undefined;
  var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return "".concat(userProfileSvcUrl, "/patient-insurance/").concat(accountId, "/cards/").concat(cardId, "/parse-eligibility?").concat((0, _queryString.stringify)({
    force: force
  }));
};
exports.getParsePatientInsuranceEligibilityUrl = getParsePatientInsuranceEligibilityUrl;
var getPatientInsuranceSoharEligibilityUrl = function getPatientInsuranceSoharEligibilityUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var cardId = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(userProfileSvcUrl, "/patient-insurance/").concat(accountId, "/cards/").concat(cardId, "/sohar-eligibility");
};
exports.getPatientInsuranceSoharEligibilityUrl = getPatientInsuranceSoharEligibilityUrl;
var getParsePatientInsuranceSoharEligibilityUrl = function getParsePatientInsuranceSoharEligibilityUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var cardId = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(userProfileSvcUrl, "/patient-insurance/").concat(accountId, "/cards/").concat(cardId, "/parse-sohar-eligibility");
};
exports.getParsePatientInsuranceSoharEligibilityUrl = getParsePatientInsuranceSoharEligibilityUrl;
var getPatientInsuranceEligibilityHistoryUrl = function getPatientInsuranceEligibilityHistoryUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var cardId = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(userProfileSvcUrl, "/patient-insurance/").concat(accountId, "/cards/").concat(cardId, "/eligibility-history");
};
exports.getPatientInsuranceEligibilityHistoryUrl = getPatientInsuranceEligibilityHistoryUrl;
var getPatientSwitchToInsurance = function getPatientSwitchToInsurance() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(userProfileSvcUrl, "/patient-insurance/").concat(accountId, "/apply");
};
exports.getPatientSwitchToInsurance = getPatientSwitchToInsurance;
var getPatientSwitchFromInsurance = function getPatientSwitchFromInsurance() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(userProfileSvcUrl, "/patient-insurance/").concat(accountId, "/drop");
};
exports.getPatientSwitchFromInsurance = getPatientSwitchFromInsurance;
var getPatientSwitchInsurance = function getPatientSwitchInsurance() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var cardId = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(userProfileSvcUrl, "/patient-insurance/").concat(accountId, "/cards/").concat(cardId, "/apply");
};
exports.getPatientSwitchInsurance = getPatientSwitchInsurance;
var getCodedEncountersUrl = function getCodedEncountersUrl(query) {
  return "".concat(patientManagementSvcUrl, "/coded-encounters?").concat((0, _queryString.stringify)(query, {
    arrayFormat: 'bracket'
  }));
};
exports.getCodedEncountersUrl = getCodedEncountersUrl;
var getCodedEncounterByIdUrl = function getCodedEncounterByIdUrl(id) {
  return "".concat(patientManagementSvcUrl, "/coded-encounters/").concat(id);
};
exports.getCodedEncounterByIdUrl = getCodedEncounterByIdUrl;
var getChargeCodedEncounterPatientResponsibilityUrl = function getChargeCodedEncounterPatientResponsibilityUrl(id) {
  return "".concat(patientManagementSvcUrl, "/coded-encounters/").concat(id, "/charge-patient-responsibility");
};
exports.getChargeCodedEncounterPatientResponsibilityUrl = getChargeCodedEncounterPatientResponsibilityUrl;
var getPatientInsuranceRequestNotifications = function getPatientInsuranceRequestNotifications() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var cardId = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(userProfileSvcUrl, "/patient-insurance/").concat(accountId, "/cards/").concat(cardId, "/request-notifications");
};
exports.getPatientInsuranceRequestNotifications = getPatientInsuranceRequestNotifications;
var getSoharTestProdUploadUrl = function getSoharTestProdUploadUrl() {
  return "".concat(userProfileSvcUrl, "/patient-insurance/sohar/test");
};

// payments
exports.getSoharTestProdUploadUrl = getSoharTestProdUploadUrl;
var getPatientSubscriptionHistoryUrl = function getPatientSubscriptionHistoryUrl(patientId) {
  return "".concat(paymentSvcUrl, "/subscriptions/patients/").concat(patientId, "/history");
};
exports.getPatientSubscriptionHistoryUrl = getPatientSubscriptionHistoryUrl;
var getPatientTransactionHistoryUrl = function getPatientTransactionHistoryUrl(patientId) {
  return "".concat(paymentSvcUrl, "/subscriptions/patients/").concat(patientId, "/transactions");
};
exports.getPatientTransactionHistoryUrl = getPatientTransactionHistoryUrl;
var getPaymentMethodUrl = function getPaymentMethodUrl() {
  var paymentMethodId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(paymentSvcUrl, "/payment-methods/").concat(paymentMethodId);
};
exports.getPaymentMethodUrl = getPaymentMethodUrl;
var getDefaultPaymentMethodUrl = function getDefaultPaymentMethodUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(paymentSvcUrl, "/payment-methods/patients/").concat(patientId, "/default");
};
exports.getDefaultPaymentMethodUrl = getDefaultPaymentMethodUrl;
var getPaymentMethodsUrl = function getPaymentMethodsUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(paymentSvcUrl, "/payment-methods/patients/").concat(patientId);
};
exports.getPaymentMethodsUrl = getPaymentMethodsUrl;
var getPatientCancellationReasonsUrl = function getPatientCancellationReasonsUrl(transitionPath) {
  return "".concat(paymentSvcUrl, "/subscriptions/cancel-reasons?transitionPath=").concat(transitionPath);
};

// transactions.controller
exports.getPatientCancellationReasonsUrl = getPatientCancellationReasonsUrl;
var getPatientTransactionsUrl = function getPatientTransactionsUrl(accountId, params) {
  return "".concat(patientManagementSvcUrl, "/transactions/").concat(accountId, "?").concat((0, _queryString.stringify)(params, {
    arrayFormat: 'bracket'
  }));
};
exports.getPatientTransactionsUrl = getPatientTransactionsUrl;
var getTransactionsForBookingUrl = function getTransactionsForBookingUrl(accountId, bookingId, params) {
  return "".concat(patientManagementSvcUrl, "/transactions/").concat(accountId, "/").concat(bookingId, "?").concat((0, _queryString.stringify)(params, {
    arrayFormat: 'bracket'
  }));
};
exports.getTransactionsForBookingUrl = getTransactionsForBookingUrl;
var getChargeTransactionUrl = function getChargeTransactionUrl(transactionId) {
  return "".concat(patientManagementSvcUrl, "/transactions/").concat(transactionId, "/charge");
};
exports.getChargeTransactionUrl = getChargeTransactionUrl;
var getRefundTransactionUrl = function getRefundTransactionUrl(transactionId) {
  return "".concat(patientManagementSvcUrl, "/transactions/").concat(transactionId, "/refund");
};
exports.getRefundTransactionUrl = getRefundTransactionUrl;
var getRetryTransactionUrl = function getRetryTransactionUrl(transactionId) {
  return "".concat(patientManagementSvcUrl, "/transactions/").concat(transactionId, "/retry");
};

//communication
exports.getRetryTransactionUrl = getRetryTransactionUrl;
var getPatientChatsSyncUrl = function getPatientChatsSyncUrl(accountId) {
  return "".concat(communicationSvcUrl, "/chats/accounts/").concat(accountId, "/sync");
};
exports.getPatientChatsSyncUrl = getPatientChatsSyncUrl;
var getUpdatePatientChatUrl = function getUpdatePatientChatUrl() {
  return "".concat(communicationSvcUrl, "/chats/shallow-update");
};
exports.getUpdatePatientChatUrl = getUpdatePatientChatUrl;
var getVideoCallUrl = function getVideoCallUrl(accountId) {
  return "".concat(communicationSvcUrl, "/video-calls/participants/").concat(accountId);
};
exports.getVideoCallUrl = getVideoCallUrl;
var getMakeTransferUrl = function getMakeTransferUrl() {
  return "".concat(paymentSvcUrl, "/tasks/transfer");
};
exports.getMakeTransferUrl = getMakeTransferUrl;
var getMakeTransferNewUrl = function getMakeTransferNewUrl(isPreview) {
  return "".concat(paymentSvcUrl, "/tasks/transfer-new?").concat((0, _queryString.stringify)({
    isPreview: isPreview
  }));
};
exports.getMakeTransferNewUrl = getMakeTransferNewUrl;
var getBalanceTransferPreviewUrl = function getBalanceTransferPreviewUrl() {
  return "".concat(paymentSvcUrl, "/tasks/transfer-preview");
};
exports.getBalanceTransferPreviewUrl = getBalanceTransferPreviewUrl;
var deleteVideoCallUrl = function deleteVideoCallUrl(sessionId, connectionId) {
  return "".concat(communicationSvcUrl, "/video-calls/rooms/").concat(sessionId, "/delete/").concat(connectionId);
};
exports.deleteVideoCallUrl = deleteVideoCallUrl;
var getVideoCallStartUrl = function getVideoCallStartUrl(roomId) {
  return "".concat(communicationSvcUrl, "/video-calls/rooms/").concat(roomId);
};
exports.getVideoCallStartUrl = getVideoCallStartUrl;
var getChatCredentialsUrl = function getChatCredentialsUrl() {
  var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(communicationSvcUrl, "/chats/accounts/").concat(userId, "/credentials");
};
exports.getChatCredentialsUrl = getChatCredentialsUrl;
var getBanUserUrl = function getBanUserUrl(channelId, userId) {
  return "".concat(communicationSvcUrl, "/chats/").concat(channelId, "/accounts/").concat(userId, "/ban");
};
exports.getBanUserUrl = getBanUserUrl;
var getUnbanUserUrl = function getUnbanUserUrl(channelId, userId) {
  return "".concat(communicationSvcUrl, "/chats/").concat(channelId, "/accounts/").concat(userId, "/unban");
};
exports.getUnbanUserUrl = getUnbanUserUrl;
var getUserPublicChatBanUrl = function getUserPublicChatBanUrl(userId) {
  return "".concat(communicationSvcUrl, "/chats/accounts/").concat(userId, "/public-chats-ban");
};
exports.getUserPublicChatBanUrl = getUserPublicChatBanUrl;
var getChannelMemberUrl = function getChannelMemberUrl(channelId, userId) {
  return "".concat(communicationSvcUrl, "/chats/").concat(channelId, "/members/").concat(userId);
};
exports.getChannelMemberUrl = getChannelMemberUrl;
var getTopCommunityMessages = function getTopCommunityMessages() {
  return "".concat(communicationSvcUrl, "/chats/top-community-posts");
};

// groups
exports.getTopCommunityMessages = getTopCommunityMessages;
var getGroupUrl = function getGroupUrl(groupId, includePast) {
  return "".concat((0, _lodash.compact)([communicationSvcUrl, 'groups', groupId]).join('/'), "?").concat((0, _queryString.stringify)({
    includePastSessions: includePast
  }));
};
exports.getGroupUrl = getGroupUrl;
var getBasicGroupsUrl = function getBasicGroupsUrl() {
  return "".concat(communicationSvcUrl, "/groups/basic");
};
exports.getBasicGroupsUrl = getBasicGroupsUrl;
var getFilteredGroupUrl = function getFilteredGroupUrl(query) {
  return "".concat((0, _lodash.compact)([communicationSvcUrl, 'groups']).join('/'), "?").concat((0, _queryString.stringify)(query));
};
exports.getFilteredGroupUrl = getFilteredGroupUrl;
var getGroupsByClinicianUrl = function getGroupsByClinicianUrl() {
  var clinicianId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return [communicationSvcUrl, 'groups/clinician', clinicianId].join('/');
};
exports.getGroupsByClinicianUrl = getGroupsByClinicianUrl;
var getGroupImageUploadUrl = function getGroupImageUploadUrl(groupId) {
  return "".concat(communicationSvcUrl, "/groups/").concat(groupId, "/images");
};
exports.getGroupImageUploadUrl = getGroupImageUploadUrl;
var getCdnBucketImageUrl = function getCdnBucketImageUrl(id) {
  return "".concat(process.env.REACT_APP_S3_NON_SENSITIVE_CDN, "/").concat(id);
};
exports.getCdnBucketImageUrl = getCdnBucketImageUrl;
var getGroupSessionsUrl = function getGroupSessionsUrl(groupId) {
  return "".concat(communicationSvcUrl, "/group-sessions/groups/").concat(groupId);
};
exports.getGroupSessionsUrl = getGroupSessionsUrl;
var getSessionUrl = function getSessionUrl(sessionId) {
  return "".concat(communicationSvcUrl, "/group-sessions/").concat(sessionId);
};
exports.getSessionUrl = getSessionUrl;
var getGroupVideoTokenUrl = function getGroupVideoTokenUrl(groupId) {
  return "".concat(communicationSvcUrl, "/groups/").concat(groupId, "/meeting-token");
};
exports.getGroupVideoTokenUrl = getGroupVideoTokenUrl;
var getGroupSessionRsvpUrl = function getGroupSessionRsvpUrl() {
  return "".concat(communicationSvcUrl, "/group-session-rsvps");
};
exports.getGroupSessionRsvpUrl = getGroupSessionRsvpUrl;
var deleteGroupSessionRsvpUrl = function deleteGroupSessionRsvpUrl(rsvpId) {
  var patientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'me';
  return "".concat(communicationSvcUrl, "/group-session-rsvps/").concat(rsvpId, "/patients/").concat(patientId);
};
exports.deleteGroupSessionRsvpUrl = deleteGroupSessionRsvpUrl;
var getGroupSessionRsvpsByPatientUrl = function getGroupSessionRsvpsByPatientUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var rsvpStatus = arguments.length > 1 ? arguments[1] : undefined;
  var includePast = arguments.length > 2 ? arguments[2] : undefined;
  return "".concat(communicationSvcUrl, "/group-session-rsvps/patients/").concat(patientId, "?").concat((0, _queryString.stringify)({
    rsvpStatus: rsvpStatus,
    includePast: includePast
  }));
};
exports.getGroupSessionRsvpsByPatientUrl = getGroupSessionRsvpsByPatientUrl;
var getAttendGroupSessionUrl = function getAttendGroupSessionUrl(groupId) {
  return "".concat(communicationSvcUrl, "/group-sessions/groups/").concat(groupId, "/attend");
};
exports.getAttendGroupSessionUrl = getAttendGroupSessionUrl;
var getGroupSessionParticipationUrl = function getGroupSessionParticipationUrl(sessionId) {
  return "".concat(communicationSvcUrl, "/group-sessions/").concat(sessionId, "/participation");
};
exports.getGroupSessionParticipationUrl = getGroupSessionParticipationUrl;
var getGroupSessionParticipationForPatientUrl = function getGroupSessionParticipationForPatientUrl(patientId) {
  return "".concat(communicationSvcUrl, "/group-sessions/patients/").concat(patientId, "/participation");
};
exports.getGroupSessionParticipationForPatientUrl = getGroupSessionParticipationForPatientUrl;
var getHasEngagedGroupSessionForPatientUrl = function getHasEngagedGroupSessionForPatientUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(communicationSvcUrl, "/group-sessions/patients/").concat(accountId, "/has-engaged");
};
exports.getHasEngagedGroupSessionForPatientUrl = getHasEngagedGroupSessionForPatientUrl;
var getGroupReviewsUrl = function getGroupReviewsUrl(groupId, startDate, endDate) {
  return "".concat(communicationSvcUrl, "/rating-review/group/").concat(groupId, "/reviews?startDate=").concat(startDate, "&endDate=").concat(endDate);
};
exports.getGroupReviewsUrl = getGroupReviewsUrl;
var getGroupAverageRatingUrl = function getGroupAverageRatingUrl(groupId) {
  return "".concat(communicationSvcUrl, "/rating-review/group/").concat(groupId, "/average-rating");
};
exports.getGroupAverageRatingUrl = getGroupAverageRatingUrl;
var getUpdateRelatedGroupsUrl = function getUpdateRelatedGroupsUrl(id) {
  return "".concat(communicationSvcUrl, "/groups/").concat(id, "/related");
};
exports.getUpdateRelatedGroupsUrl = getUpdateRelatedGroupsUrl;
var getGroupFavoriteUrl = function getGroupFavoriteUrl(groupId) {
  return "".concat(communicationSvcUrl, "/groups/").concat(groupId, "/patient/me/favorite");
};
exports.getGroupFavoriteUrl = getGroupFavoriteUrl;
var getGroupChatUrl = function getGroupChatUrl(groupId) {
  var patientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'me';
  return "".concat(communicationSvcUrl, "/groups/").concat(groupId, "/chat/patients/").concat(patientId);
};
exports.getGroupChatUrl = getGroupChatUrl;
var getAllGroupTopicsUrl = function getAllGroupTopicsUrl() {
  return "".concat(communicationSvcUrl, "/groups/topics");
};
exports.getAllGroupTopicsUrl = getAllGroupTopicsUrl;
var getGroupTopicsByGroupUrl = function getGroupTopicsByGroupUrl(groupId) {
  return "".concat(communicationSvcUrl, "/groups/").concat(groupId, "/topics");
};
exports.getGroupTopicsByGroupUrl = getGroupTopicsByGroupUrl;
var getGroupsWithTopicUrl = function getGroupsWithTopicUrl(topicId) {
  return "".concat(communicationSvcUrl, "/groups/topics/").concat(topicId);
};
exports.getGroupsWithTopicUrl = getGroupsWithTopicUrl;
var addTopicToGroupUrl = function addTopicToGroupUrl(groupId, topicId) {
  return "".concat(communicationSvcUrl, "/groups/").concat(groupId, "/topics/").concat(topicId);
};
exports.addTopicToGroupUrl = addTopicToGroupUrl;
var deleteTopicFromGroupUrl = function deleteTopicFromGroupUrl(groupId, topicId) {
  return "".concat(communicationSvcUrl, "/groups/").concat(groupId, "/topics/").concat(topicId);
};
exports.deleteTopicFromGroupUrl = deleteTopicFromGroupUrl;
var newTopicUrl = function newTopicUrl() {
  return "".concat(communicationSvcUrl, "/groups/topics");
};
exports.newTopicUrl = newTopicUrl;
var createTopicAndAddToGroupUrl = function createTopicAndAddToGroupUrl(groupId) {
  return "".concat(communicationSvcUrl, "/groups/").concat(groupId, "/topics");
};
exports.createTopicAndAddToGroupUrl = createTopicAndAddToGroupUrl;
var getPublicClinicianListUrl = function getPublicClinicianListUrl() {
  return "".concat(communicationSvcUrl, "/groups/clinicians");
};

// content-library (courses, lessons)
exports.getPublicClinicianListUrl = getPublicClinicianListUrl;
var getCoursesUrl = function getCoursesUrl() {
  return "".concat(communicationSvcUrl, "/courses");
};
exports.getCoursesUrl = getCoursesUrl;
var getCourseByIdOrSlugUrl = function getCourseByIdOrSlugUrl(courseId) {
  return "".concat(communicationSvcUrl, "/courses/").concat(courseId);
};
exports.getCourseByIdOrSlugUrl = getCourseByIdOrSlugUrl;
var getCourseLessonsUrl = function getCourseLessonsUrl(courseId) {
  return "".concat(communicationSvcUrl, "/courses/").concat(courseId, "/lessons");
};
exports.getCourseLessonsUrl = getCourseLessonsUrl;
var getCourseRecommendedGroupsUrl = function getCourseRecommendedGroupsUrl(courseId) {
  return "".concat(communicationSvcUrl, "/courses/").concat(courseId, "/recommended-groups");
};
exports.getCourseRecommendedGroupsUrl = getCourseRecommendedGroupsUrl;
var getCourseImagesUrl = function getCourseImagesUrl(courseId) {
  return "".concat(communicationSvcUrl, "/courses/").concat(courseId, "/images");
};
exports.getCourseImagesUrl = getCourseImagesUrl;
var getCourseWorkbookUrl = function getCourseWorkbookUrl(courseId) {
  return "".concat(communicationSvcUrl, "/courses/").concat(courseId, "/workbook");
};
exports.getCourseWorkbookUrl = getCourseWorkbookUrl;
var getLessonsUrl = function getLessonsUrl() {
  return "".concat(communicationSvcUrl, "/lessons");
};
exports.getLessonsUrl = getLessonsUrl;
var getSingleLessonUrl = function getSingleLessonUrl(lessonSlugOrId) {
  return "".concat(communicationSvcUrl, "/lessons/").concat(lessonSlugOrId);
};
exports.getSingleLessonUrl = getSingleLessonUrl;
var getLessonImageUrl = function getLessonImageUrl(lessonId) {
  return "".concat(communicationSvcUrl, "/lessons/").concat(lessonId, "/image");
};
exports.getLessonImageUrl = getLessonImageUrl;
var getCourseImageAssetUrl = function getCourseImageAssetUrl(id) {
  return "".concat(communicationSvcUrl, "/courses/assets/images/").concat(id);
};
exports.getCourseImageAssetUrl = getCourseImageAssetUrl;
var getCourseWorkbookAssetUrl = function getCourseWorkbookAssetUrl(id) {
  return "".concat(communicationSvcUrl, "/courses/assets/workbooks/").concat(id);
};
exports.getCourseWorkbookAssetUrl = getCourseWorkbookAssetUrl;
var getFeaturedCourseUrl = function getFeaturedCourseUrl() {
  return "".concat(communicationSvcUrl, "/courses/featured-course");
};
exports.getFeaturedCourseUrl = getFeaturedCourseUrl;
var postGroupSessionsRatesDataUrl = function postGroupSessionsRatesDataUrl(_ref12) {
  var execute = _ref12.execute;
  return "".concat(communicationSvcUrl, "/group-sessions/moderator-rates/bulk-upload?execute=").concat(execute);
};

// notification preferences
exports.postGroupSessionsRatesDataUrl = postGroupSessionsRatesDataUrl;
var getPatientNotificationPreferencesUrl = function getPatientNotificationPreferencesUrl(accountId) {
  return "".concat(communicationSvcUrl, "/notifications/").concat(accountId, "/preferences");
};
exports.getPatientNotificationPreferencesUrl = getPatientNotificationPreferencesUrl;
var getPatientNotificationPreferencesDictionaryUrl = function getPatientNotificationPreferencesDictionaryUrl() {
  return "".concat(communicationSvcUrl, "/notifications/preferences/dictionary");
};
exports.getPatientNotificationPreferencesDictionaryUrl = getPatientNotificationPreferencesDictionaryUrl;
var getPatientMarketingEmailPreferenceUrl = function getPatientMarketingEmailPreferenceUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(communicationSvcUrl, "/notifications/").concat(accountId, "/emails/marketing");
};
exports.getPatientMarketingEmailPreferenceUrl = getPatientMarketingEmailPreferenceUrl;
var getPatientSmsTransactionalNotificationsAll = function getPatientSmsTransactionalNotificationsAll() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(communicationSvcUrl, "/notifications/").concat(accountId, "/sms/transactional/all");
};
exports.getPatientSmsTransactionalNotificationsAll = getPatientSmsTransactionalNotificationsAll;
var getClinicianNotificationPreferencesUrl = function getClinicianNotificationPreferencesUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(communicationSvcUrl, "/notifications/").concat(accountId, "/preferences/clinician");
};
exports.getClinicianNotificationPreferencesUrl = getClinicianNotificationPreferencesUrl;
var getClinicianNotificationPreferencesDictionaryUrl = function getClinicianNotificationPreferencesDictionaryUrl() {
  return "".concat(communicationSvcUrl, "/notifications/preferences/clinician/dictionary");
};

// csv export
exports.getClinicianNotificationPreferencesDictionaryUrl = getClinicianNotificationPreferencesDictionaryUrl;
var getExportCliniciansListCsvUrl = function getExportCliniciansListCsvUrl() {
  return "".concat(userProfileSvcUrl, "/csv/clinicians");
};
exports.getExportCliniciansListCsvUrl = getExportCliniciansListCsvUrl;
var getClinicianRatingAndReviewStatisticsCsvUrl = function getClinicianRatingAndReviewStatisticsCsvUrl(clinicianId, startDate, endDate) {
  return "".concat(communicationSvcUrl, "/csv/clinician/").concat(clinicianId, "/reviews?startDate=").concat(startDate, "&endDate=").concat(endDate);
};
exports.getClinicianRatingAndReviewStatisticsCsvUrl = getClinicianRatingAndReviewStatisticsCsvUrl;
var getGroupRatingAndReviewStatisticsCsvUrl = function getGroupRatingAndReviewStatisticsCsvUrl(groupId, startDate, endDate) {
  return "".concat(communicationSvcUrl, "/csv/group/").concat(groupId, "/reviews?startDate=").concat(startDate, "&endDate=").concat(endDate);
};
exports.getGroupRatingAndReviewStatisticsCsvUrl = getGroupRatingAndReviewStatisticsCsvUrl;
var getExportRetentionDataCsvUrl = function getExportRetentionDataCsvUrl() {
  return "".concat(paymentSvcUrl, "/subscriptions/retention");
};
exports.getExportRetentionDataCsvUrl = getExportRetentionDataCsvUrl;
var getExportLtvReportCsvUrl = function getExportLtvReportCsvUrl() {
  return "".concat(paymentSvcUrl, "/ltv-report");
};
exports.getExportLtvReportCsvUrl = getExportLtvReportCsvUrl;
var getExportActiveMembershipReportCsvUrl = function getExportActiveMembershipReportCsvUrl() {
  return "".concat(paymentSvcUrl, "/active-membership-report");
};
exports.getExportActiveMembershipReportCsvUrl = getExportActiveMembershipReportCsvUrl;
var getExportRevenueReportCsvUrl = function getExportRevenueReportCsvUrl() {
  return "".concat(paymentSvcUrl, "/revenue-report");
};
exports.getExportRevenueReportCsvUrl = getExportRevenueReportCsvUrl;
var getClinicianAvailabilityReportCsvUrl = function getClinicianAvailabilityReportCsvUrl() {
  return "".concat(patientManagementSvcUrl, "/csv/clinicians-availability-report");
};
exports.getClinicianAvailabilityReportCsvUrl = getClinicianAvailabilityReportCsvUrl;
var getPatientsStateZipInconsistenciesCsvUrl = function getPatientsStateZipInconsistenciesCsvUrl() {
  var includeChurned = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return "".concat(communicationSvcUrl, "/csv/patients/zip-state-inconsistency?").concat((0, _queryString.stringify)({
    includeChurned: includeChurned
  }));
};
exports.getPatientsStateZipInconsistenciesCsvUrl = getPatientsStateZipInconsistenciesCsvUrl;
var getDownloadPayerFeeSchedulesUrl = function getDownloadPayerFeeSchedulesUrl() {
  return "".concat(patientManagementSvcUrl, "/csv/payer-fee-schedules");
};

// health outcomes
exports.getDownloadPayerFeeSchedulesUrl = getDownloadPayerFeeSchedulesUrl;
var getHealthOutcomesPatientExportUrl = function getHealthOutcomesPatientExportUrl(patientId) {
  return "".concat(patientManagementSvcUrl, "/csv/health-outcomes/patients/").concat(patientId);
};
exports.getHealthOutcomesPatientExportUrl = getHealthOutcomesPatientExportUrl;
var getHealthOutcomesReportSendingUrl = function getHealthOutcomesReportSendingUrl(reportType) {
  return "".concat(patientManagementSvcUrl, "/csv/health-outcomes/").concat(reportType);
};
exports.getHealthOutcomesReportSendingUrl = getHealthOutcomesReportSendingUrl;
var getGeneratedNickname = function getGeneratedNickname() {
  return "".concat(userProfileSvcUrl, "/accounts/generate/nickname");
};

// public reviews
exports.getGeneratedNickname = getGeneratedNickname;
var getPublicFacingReviewsUrl = function getPublicFacingReviewsUrl(_ref13) {
  var _ref13$type = _ref13.type,
    type = _ref13$type === void 0 ? 'group' : _ref13$type,
    _ref13$page = _ref13.page,
    page = _ref13$page === void 0 ? 1 : _ref13$page,
    _ref13$limit = _ref13.limit,
    limit = _ref13$limit === void 0 ? 10 : _ref13$limit,
    groupId = _ref13.groupId;
  return "".concat(communicationSvcUrl, "/rating-review/public-facing?").concat((0, _queryString.stringify)({
    type: type,
    page: page,
    limit: limit,
    groupId: groupId
  }));
};

// bookings
exports.getPublicFacingReviewsUrl = getPublicFacingReviewsUrl;
var getPatientBookingsUrl = function getPatientBookingsUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var query = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(patientManagementSvcUrl, "/bookings/account/").concat(accountId).concat(query ? '?' + (0, _queryString.stringify)(query) : '');
};
exports.getPatientBookingsUrl = getPatientBookingsUrl;
var getBookingsForAnalysisUrl = function getBookingsForAnalysisUrl(query) {
  var accountId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'me';
  return "".concat(patientManagementSvcUrl, "/bookings/analysis/").concat(accountId).concat(query ? '?' + (0, _queryString.stringify)(query) : '');
};
exports.getBookingsForAnalysisUrl = getBookingsForAnalysisUrl;
var getBookingsCsvUrl = function getBookingsCsvUrl(query) {
  return "".concat(patientManagementSvcUrl, "/csv/bookings").concat(query ? '?' + (0, _queryString.stringify)(query) : '');
};
exports.getBookingsCsvUrl = getBookingsCsvUrl;
var getBookingUrl = function getBookingUrl(bookingId) {
  return "".concat(patientManagementSvcUrl, "/bookings/").concat(bookingId);
};
exports.getBookingUrl = getBookingUrl;
var getBookingsForNoteUrl = function getBookingsForNoteUrl(patientId) {
  return "".concat(patientManagementSvcUrl, "/bookings/patient/").concat(patientId, "/note");
};
exports.getBookingsForNoteUrl = getBookingsForNoteUrl;
var getCloseBookingUrl = function getCloseBookingUrl(clinicianId, patientId) {
  return "".concat(patientManagementSvcUrl, "/bookings/clinicians/").concat(clinicianId, "/close-booking/").concat(patientId);
};
exports.getCloseBookingUrl = getCloseBookingUrl;
var getExtendBookingConflictsUrl = function getExtendBookingConflictsUrl(clinicianId, bookingId) {
  return "".concat(patientManagementSvcUrl, "/bookings/clinicians/").concat(clinicianId, "/extend-booking-conflicts/").concat(bookingId);
};
exports.getExtendBookingConflictsUrl = getExtendBookingConflictsUrl;
var getExtendBookingUrl = function getExtendBookingUrl(clinicianId, bookingId) {
  return "".concat(patientManagementSvcUrl, "/bookings/clinicians/").concat(clinicianId, "/extend-booking/").concat(bookingId);
};
exports.getExtendBookingUrl = getExtendBookingUrl;
var getChargeDepositForBookingUrl = function getChargeDepositForBookingUrl(bookingId) {
  var patientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'me';
  return "".concat(paymentSvcUrl, "/bookings/").concat(bookingId, "/patients/").concat(patientId, "/deposit");
};
exports.getChargeDepositForBookingUrl = getChargeDepositForBookingUrl;
var getValidateDepositPaymentForBookingUrl = function getValidateDepositPaymentForBookingUrl(bookingId) {
  var patientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'me';
  return "".concat(paymentSvcUrl, "/bookings-payment-validation/").concat(bookingId, "/patients/").concat(patientId, "/deposit");
};
exports.getValidateDepositPaymentForBookingUrl = getValidateDepositPaymentForBookingUrl;
var getPatientNonCancelledBookingsUrl = function getPatientNonCancelledBookingsUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/bookings/account/").concat(accountId, "/non-cancelled");
};
exports.getPatientNonCancelledBookingsUrl = getPatientNonCancelledBookingsUrl;
var postBookingClinicianRatesDataUrl = function postBookingClinicianRatesDataUrl(_ref14) {
  var execute = _ref14.execute;
  return "".concat(patientManagementSvcUrl, "/bookings/clinician-rates/bulk-upload?execute=").concat(execute);
};
exports.postBookingClinicianRatesDataUrl = postBookingClinicianRatesDataUrl;
var getCreateAppointmentUrl = function getCreateAppointmentUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/scheduling/patients/").concat(accountId, "/appointments");
};
exports.getCreateAppointmentUrl = getCreateAppointmentUrl;
var getUpdateAppointmentClinicianRateUrl = function getUpdateAppointmentClinicianRateUrl(appointmentId) {
  var accountId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'me';
  return "".concat(patientManagementSvcUrl, "/scheduling/accounts/").concat(accountId, "/appointments/").concat(appointmentId, "/clinician-rate");
};
exports.getUpdateAppointmentClinicianRateUrl = getUpdateAppointmentClinicianRateUrl;
var getUpdateAppointmentUrl = function getUpdateAppointmentUrl(_ref15) {
  var appointmentId = _ref15.appointmentId,
    _ref15$accountId = _ref15.accountId,
    accountId = _ref15$accountId === void 0 ? 'me' : _ref15$accountId,
    _ref15$query = _ref15.query,
    query = _ref15$query === void 0 ? {} : _ref15$query;
  return "".concat(patientManagementSvcUrl, "/scheduling/accounts/").concat(accountId, "/appointments/").concat(appointmentId, "?").concat((0, _queryString.stringify)(query));
};
exports.getUpdateAppointmentUrl = getUpdateAppointmentUrl;
var getCancelAppointmentUrl = getUpdateAppointmentUrl;
exports.getCancelAppointmentUrl = getCancelAppointmentUrl;
var getRecurringAvailabilityUrl = function getRecurringAvailabilityUrl(clinicianId, query) {
  return "".concat(patientManagementSvcUrl, "/scheduling/clinicians/").concat(clinicianId, "/recurring-availability").concat(query ? '?' + (0, _queryString.stringify)(query) : '');
};
exports.getRecurringAvailabilityUrl = getRecurringAvailabilityUrl;
var getCreateRecurringAppointmentUrl = function getCreateRecurringAppointmentUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/scheduling/patients/").concat(accountId, "/recurring-rules");
};
exports.getCreateRecurringAppointmentUrl = getCreateRecurringAppointmentUrl;
var getUpdateRecurringAppointmentUrl = function getUpdateRecurringAppointmentUrl(_ref16) {
  var recurringRuleId = _ref16.recurringRuleId,
    _ref16$accountId = _ref16.accountId,
    accountId = _ref16$accountId === void 0 ? 'me' : _ref16$accountId,
    _ref16$query = _ref16.query,
    query = _ref16$query === void 0 ? {} : _ref16$query;
  return "".concat(patientManagementSvcUrl, "/scheduling/accounts/").concat(accountId, "/recurring-rules/").concat(recurringRuleId, "?").concat((0, _queryString.stringify)(query));
};
exports.getUpdateRecurringAppointmentUrl = getUpdateRecurringAppointmentUrl;
var getCancelRecurringAppointmentUrl = getUpdateRecurringAppointmentUrl;
exports.getCancelRecurringAppointmentUrl = getCancelRecurringAppointmentUrl;
var getAppointmentSchedulingFlowTransitionUrl = function getAppointmentSchedulingFlowTransitionUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/scheduling-flow/").concat(accountId, "/transition");
};
exports.getAppointmentSchedulingFlowTransitionUrl = getAppointmentSchedulingFlowTransitionUrl;
var getAppointmentSchedulingFlowUrl = function getAppointmentSchedulingFlowUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/scheduling-flow/").concat(accountId);
};
exports.getAppointmentSchedulingFlowUrl = getAppointmentSchedulingFlowUrl;
var getAppointmentSchedulingFlowMostRecentVisitReasonUrl = function getAppointmentSchedulingFlowMostRecentVisitReasonUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/scheduling-flow/").concat(accountId, "/visit-reason");
};
exports.getAppointmentSchedulingFlowMostRecentVisitReasonUrl = getAppointmentSchedulingFlowMostRecentVisitReasonUrl;
var getAppointmentSchedulingFlowForClinicianRoleUrl = function getAppointmentSchedulingFlowForClinicianRoleUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var clinicianRole = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(patientManagementSvcUrl, "/scheduling-flow/").concat(accountId, "/role/").concat(clinicianRole);
};
exports.getAppointmentSchedulingFlowForClinicianRoleUrl = getAppointmentSchedulingFlowForClinicianRoleUrl;
var getCreateSchedulingFlowAppointmentAndDepositUrl = function getCreateSchedulingFlowAppointmentAndDepositUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var clinicianRole = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(patientManagementSvcUrl, "/scheduling-flow-appointment/").concat(patientId, "?role=").concat(clinicianRole);
};

// notifications
exports.getCreateSchedulingFlowAppointmentAndDepositUrl = getCreateSchedulingFlowAppointmentAndDepositUrl;
var getNotificationsUrl = function getNotificationsUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(communicationSvcUrl, "/notifications/").concat(accountId);
};

//scheduling
exports.getNotificationsUrl = getNotificationsUrl;
var getSchedulingAccessTokenUrl = function getSchedulingAccessTokenUrl() {
  return "".concat(patientManagementSvcUrl, "/scheduling/me/access-token");
};
exports.getSchedulingAccessTokenUrl = getSchedulingAccessTokenUrl;
var getSchedulingElementTokenUrl = function getSchedulingElementTokenUrl() {
  return "".concat(patientManagementSvcUrl, "/scheduling/me/element-token");
};
exports.getSchedulingElementTokenUrl = getSchedulingElementTokenUrl;
var getClinicianAvailabilityUrl = function getClinicianAvailabilityUrl(query) {
  return "".concat(patientManagementSvcUrl, "/scheduling/clinicians/availability?").concat((0, _queryString.stringify)(query));
};
exports.getClinicianAvailabilityUrl = getClinicianAvailabilityUrl;
var getClinicianAvailabilityValidationUrl = function getClinicianAvailabilityValidationUrl(clinicianId, query) {
  return "".concat(patientManagementSvcUrl, "/scheduling/clinicians/").concat(clinicianId, "/availability/validate?").concat((0, _queryString.stringify)(query));
};
exports.getClinicianAvailabilityValidationUrl = getClinicianAvailabilityValidationUrl;
var getClinicianAvailablePeriodsUrl = function getClinicianAvailablePeriodsUrl() {
  var clinicianId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/scheduling/clinicians/").concat(clinicianId, "/available-periods");
};
exports.getClinicianAvailablePeriodsUrl = getClinicianAvailablePeriodsUrl;
var getClinicianAvailabilityRulesUrl = function getClinicianAvailabilityRulesUrl() {
  var clinicianId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/scheduling/clinicians/").concat(clinicianId, "/availability-rules");
};
exports.getClinicianAvailabilityRulesUrl = getClinicianAvailabilityRulesUrl;
var getClinicianCalendarsUrl = function getClinicianCalendarsUrl() {
  var clinicianId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/scheduling/clinicians/").concat(clinicianId, "/calendars");
};
exports.getClinicianCalendarsUrl = getClinicianCalendarsUrl;
var getClinicianBlockingEventsUrl = function getClinicianBlockingEventsUrl() {
  var clinicianId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var _ref17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    onlyNonAppointmentEvents = _ref17.onlyNonAppointmentEvents,
    attachPatientData = _ref17.attachPatientData;
  return "".concat(patientManagementSvcUrl, "/scheduling/clinicians/").concat(clinicianId, "/blocking-events?").concat((0, _queryString.stringify)({
    onlyNonAppointmentEvents: onlyNonAppointmentEvents,
    attachPatientData: attachPatientData
  }));
};
exports.getClinicianBlockingEventsUrl = getClinicianBlockingEventsUrl;
var getCronofyProfileUrl = function getCronofyProfileUrl() {
  var clinicianId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/scheduling/clinicians/").concat(clinicianId, "/cronofy-profile");
};
exports.getCronofyProfileUrl = getCronofyProfileUrl;
var getCronofyUserInfoUrl = function getCronofyUserInfoUrl(elementToken) {
  return "https://api.cronofy.com/v1/userinfo?et=".concat(elementToken);
};
exports.getCronofyUserInfoUrl = getCronofyUserInfoUrl;
var getApplicationCalendarUrl = function getApplicationCalendarUrl() {
  var clinicianId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/scheduling/clinicians/").concat(clinicianId, "/application-calendars");
};
exports.getApplicationCalendarUrl = getApplicationCalendarUrl;
var getSchedulingTherapistRecommendationUrl = function getSchedulingTherapistRecommendationUrl(clinicianId) {
  var exclude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return "".concat(patientManagementSvcUrl, "/scheduling-recommendation/therapist").concat(clinicianId ? "/".concat(clinicianId) : '', "?").concat((0, _queryString.stringify)({
    exclude: exclude
  }));
};
exports.getSchedulingTherapistRecommendationUrl = getSchedulingTherapistRecommendationUrl;
var getSchedulingPhysicianRecommendationUrl = function getSchedulingPhysicianRecommendationUrl(clinicianId) {
  var exclude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return "".concat(patientManagementSvcUrl, "/scheduling-recommendation/physician").concat(clinicianId ? "/".concat(clinicianId) : '', "?").concat((0, _queryString.stringify)({
    exclude: exclude
  }));
};
exports.getSchedulingPhysicianRecommendationUrl = getSchedulingPhysicianRecommendationUrl;
var getBustAvailabilityCacheUrl = function getBustAvailabilityCacheUrl() {
  var clinicianId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(patientManagementSvcUrl, "/scheduling/bust-cache/").concat(clinicianId);
};
exports.getBustAvailabilityCacheUrl = getBustAvailabilityCacheUrl;
var getPatientTopicsUrl = function getPatientTopicsUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(userProfileSvcUrl, "/patients/").concat(accountId, "/topics");
};
exports.getPatientTopicsUrl = getPatientTopicsUrl;
var getGroupRecommendationsByPatientUrl = function getGroupRecommendationsByPatientUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(userProfileSvcUrl, "/patients/").concat(accountId, "/grouprecommendations");
};
exports.getGroupRecommendationsByPatientUrl = getGroupRecommendationsByPatientUrl;
var getPatientInsuranceCardsList = function getPatientInsuranceCardsList(query) {
  return "".concat(userProfileSvcUrl, "/patient-insurance/cards?").concat((0, _queryString.stringify)(query));
};
exports.getPatientInsuranceCardsList = getPatientInsuranceCardsList;
var getPatientInsuranceCardAndBenefitData = function getPatientInsuranceCardAndBenefitData(accountId, cardId) {
  return "".concat(userProfileSvcUrl, "/patient-insurance/").concat(accountId, "/cards/").concat(cardId);
};
exports.getPatientInsuranceCardAndBenefitData = getPatientInsuranceCardAndBenefitData;
var getAddModeratorsToChannelUrl = function getAddModeratorsToChannelUrl(channelId, query) {
  return "".concat(communicationSvcUrl, "/chats/").concat(channelId, "/moderators?").concat((0, _queryString.stringify)(query, {
    arrayFormat: 'bracket'
  }));
};
exports.getAddModeratorsToChannelUrl = getAddModeratorsToChannelUrl;
var getChannelModeratorsUrl = function getChannelModeratorsUrl(channelId) {
  return "".concat(communicationSvcUrl, "/chats/").concat(channelId, "/moderators");
};
exports.getChannelModeratorsUrl = getChannelModeratorsUrl;
var getEmailTemplatesUrl = function getEmailTemplatesUrl() {
  var templateName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(communicationSvcUrl, "/message-previews/email/").concat(templateName);
};
exports.getEmailTemplatesUrl = getEmailTemplatesUrl;
var getSmsTemplatesUrl = function getSmsTemplatesUrl() {
  var templateName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(communicationSvcUrl, "/message-previews/sms/").concat(templateName);
};

// employer
exports.getSmsTemplatesUrl = getSmsTemplatesUrl;
var getEmployersUrl = function getEmployersUrl() {
  return "".concat(userProfileSvcUrl, "/employers");
};

// patient employer relation
exports.getEmployersUrl = getEmployersUrl;
var getPatientEmployerRelationsUrl = function getPatientEmployerRelationsUrl(patientId) {
  return "".concat(userProfileSvcUrl, "/patient-employer-relations?").concat((0, _queryString.stringify)({
    patientId: patientId
  }));
};
exports.getPatientEmployerRelationsUrl = getPatientEmployerRelationsUrl;
var getUploadPatientEmployerRelationsUrl = function getUploadPatientEmployerRelationsUrl(_ref18) {
  var employerId = _ref18.employerId,
    execute = _ref18.execute;
  return "".concat(userProfileSvcUrl, "/patient-employer-relations/").concat(employerId, "?execute=").concat(execute);
};

// getCouponIsEmployerCodeUrl, but obfuscated
exports.getUploadPatientEmployerRelationsUrl = getUploadPatientEmployerRelationsUrl;
var getCIECU = function getCIECU(e, u) {
  return "".concat(paymentSvcUrl, "/coupons/validate/").concat(e, "/").concat(u);
};

// membership
exports.getCIECU = getCIECU;
var getPatientMembershipUrl = function getPatientMembershipUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(paymentSvcUrl, "/membership/patients/").concat(patientId);
};
exports.getPatientMembershipUrl = getPatientMembershipUrl;
var getPatientLegacyCommunityOnlyUrl = function getPatientLegacyCommunityOnlyUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(paymentSvcUrl, "/membership/patients/").concat(patientId, "/community-only");
};

// prices
exports.getPatientLegacyCommunityOnlyUrl = getPatientLegacyCommunityOnlyUrl;
var getPricesForPatientUrl = function getPricesForPatientUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(paymentSvcUrl, "/prices/").concat(patientId);
};
exports.getPricesForPatientUrl = getPricesForPatientUrl;
var getDiscountedPricesUrl = function getDiscountedPricesUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var couponId = arguments.length > 1 ? arguments[1] : undefined;
  return "".concat(paymentSvcUrl, "/prices/").concat(patientId, "/discount/").concat(couponId);
};
exports.getDiscountedPricesUrl = getDiscountedPricesUrl;
var getAllPricesUrl = function getAllPricesUrl() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(paymentSvcUrl, "/prices/").concat(patientId, "/all");
};
exports.getAllPricesUrl = getAllPricesUrl;
var getPatientPhoneNumberVerificationUrl = function getPatientPhoneNumberVerificationUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(communicationSvcUrl, "/phone-number-verification/").concat(accountId);
};
exports.getPatientPhoneNumberVerificationUrl = getPatientPhoneNumberVerificationUrl;
var getPatientPhoneNumberVerificationSkipUrl = function getPatientPhoneNumberVerificationSkipUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(communicationSvcUrl, "/phone-number-verification/").concat(accountId, "/skip");
};
exports.getPatientPhoneNumberVerificationSkipUrl = getPatientPhoneNumberVerificationSkipUrl;
var getNoClinicianAvailabilitySupportTicketUrl = function getNoClinicianAvailabilitySupportTicketUrl() {
  var accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "".concat(communicationSvcUrl, "/support-tickets/").concat(accountId, "/no-clinician-availability");
};
exports.getNoClinicianAvailabilitySupportTicketUrl = getNoClinicianAvailabilitySupportTicketUrl;
var getUsaStateByZipUrl = function getUsaStateByZipUrl(zipCode) {
  return "".concat(communicationSvcUrl, "/usa-states/by-zip/").concat(zipCode);
};

// tempest migration
exports.getUsaStateByZipUrl = getUsaStateByZipUrl;
var getTempestStripeCopyUploadUrl = function getTempestStripeCopyUploadUrl() {
  return "".concat(userProfileSvcUrl, "/accounts/tempest-stripe-copy");
};
exports.getTempestStripeCopyUploadUrl = getTempestStripeCopyUploadUrl;
var getTempestMigrationUploadUrl = function getTempestMigrationUploadUrl() {
  return "".concat(userProfileSvcUrl, "/accounts/tempest-migration");
};

// post appointment state
exports.getTempestMigrationUploadUrl = getTempestMigrationUploadUrl;
var getPostAppointmentStateUrl = function getPostAppointmentStateUrl() {
  var bookingId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  return "".concat(patientManagementSvcUrl, "/post-appointment-state").concat(bookingId ? "/".concat(bookingId) : '');
};
exports.getPostAppointmentStateUrl = getPostAppointmentStateUrl;
var getPostAppointmentClinicianStateUrl = function getPostAppointmentClinicianStateUrl() {
  var bookingId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(patientManagementSvcUrl, "/post-appointment-state/").concat(bookingId, "/clinician");
};
exports.getPostAppointmentClinicianStateUrl = getPostAppointmentClinicianStateUrl;
var getNpiValidatorsUrl = function getNpiValidatorsUrl(value) {
  return "/api/npi/clinicians/".concat(value, "/verify");
};
exports.getNpiValidatorsUrl = getNpiValidatorsUrl;
var getDownloadMembersForMigrationToCommunityApp = function getDownloadMembersForMigrationToCommunityApp(forStripe) {
  return "".concat(userProfileSvcUrl, "/patients/download/for-community-app?forStripe=").concat(forStripe);
};
exports.getDownloadMembersForMigrationToCommunityApp = getDownloadMembersForMigrationToCommunityApp;